import {
  CreateProductOptionAPI,
  UpdateProductOptionAPI,
} from 'types/product/productOptionTypes';
import { AxiosResponse } from 'axios';
import { APIClient } from 'services/helpers/api_helper';

import * as url from 'services/helpers/url_helper';
import {
  GetProductOptionByIDResponse,
  GetProductOptionListResponse,
} from 'types/APIResponsesTypes';
import { SortOrder } from 'types/common/Sorting';
import { GetProductOptionListRequest } from 'types/product/productOptionTypes';
import { SuccessResponse } from 'types/ResponseTypes';

const api = new APIClient();

export const getProductOptionList = async (
  keyword = '',
  limit = 10,
  page = 1,
  sort_by = 'sort_order',
  sort_order = 'asc'
) => {
  const req: GetProductOptionListRequest = {
    keyword: keyword,
    limit: limit,
    page: page,
    sort_by: sort_by,
    sort_order: sort_order,
  };

  try {
    const response: Promise<GetProductOptionListResponse> = await api.get(
      url.GET_PRODUCT_OPTION_LIST,
      req
    );
    return response;
    // if (response) {
    //   const { message, error_code, data } = response;
    //   if (message === 'OK' && error_code === 0) {
    //     return data;
    //   } else {
    //     return { total: 0, product_options: [] };
    //   }
    // }
    // return { total: 0, product_options: [] };
  } catch (error) {
    return Promise.reject(error);
  }
};
export const getCheckTotalProductOptions = async () => {
  try {
    const response: Promise<GetProductOptionListResponse> = await api.get(
      url.GET_CHECK_TOTAL_PRODUCT_OPTIONS
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getProductOptionByID = async (id: string) => {
  try {
    const response: GetProductOptionByIDResponse = await api.get(
      url.GET_PRODUCT_OPTION_BY_ID + id
    );
    if (response) {
      const { message, error_code, data } = response;
      if (message === 'OK' && error_code === 0) {
        return data;
      } else {
        return null;
      }
    }
    return null;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const putUpdateProductOption = async (req: UpdateProductOptionAPI) => {
  try {
    const response: SuccessResponse = await api.put(
      url.PUT_UPDATE_PRODUCT_OPTION,
      req
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const putUpdateSortOrderProductOption = async (
  sortedData: SortOrder[]
) => {
  const req = {
    product_options: sortedData,
  };
  try {
    const response: SuccessResponse = await api.put(
      url.PUT_PRODUCT_OPTION_SORT_ORDER,
      req
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteProductOptionById = async (id: string) => {
  try {
    const response: AxiosResponse<SuccessResponse> = await api.delete(
      url.DELETE_PRODUCT_OPTION_BY_ID + id
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

//todo need edit
export const patchUpdateSortOrderProductOption = async (id: string) => {
  try {
    const response: GetProductOptionByIDResponse = await api.get(
      url.GET_PRODUCT_OPTION_BY_ID + id
    );
    if (response) {
      const { message, error_code, data } = response;
      if (message === 'OK' && error_code === 0) {
        return data;
      } else {
        return null;
      }
    }
    return null;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postAddProductOption = async (req: CreateProductOptionAPI) => {
  try {
    const response: SuccessResponse = await api.create(
      url.POST_ADD_PRODUCT_OPTION,
      req
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const postCheckProductOptionExists = async (name: string) => {
  try {
    const response: SuccessResponse = await api.create(
      url.POST_CHECK_PRODUCT_OPTION_EXISTS,
      {
        product_option_name: name,
      }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
